import { createSlice } from "@reduxjs/toolkit";

export const mapSettingSlice = createSlice({
    name: 'mapsetting',
    initialState: {
        highlight : true,
        areaname: true,
        areaonly: false
    },
    reducers: {
        setMapSettingHighlight: (state, action) => {
            state.highlight = action.payload;
        },
        setMapSettingAreaName: (state, action) => {
            state.areaname = action.payload;
        },
        setMapSettingAreaOnly: (state, action) => {
            state.areaonly = action.payload;
        }
    }
})

export const { setMapSettingHighlight, setMapSettingAreaName, setMapSettingAreaOnly } = mapSettingSlice.actions;

export const getMapSettingHighlight = (state) => state.mapsetting.highlight;
export const getMapSettingAreaName = (state) => state.mapsetting.areaname;
export const getMapSettingAreaOnly = (state) => state.mapsetting.areaonly;


export default mapSettingSlice.reducer;